import { Switch } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import {
  LuCalendar,
  LuCamera,
  LuCheck,
  LuFileText,
  LuLinkedin,
  LuLoader,
  LuMail,
  LuRefreshCw,
  LuSave,
  LuUnplug,
  LuUser
} from "react-icons/lu";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import { API_URL } from "../../../constants";
import { apiDelete, apiGet, apiPost, getCurrentUserProfileImage, toastError, toastSuccess } from "../../../utils";
import DemoBookings from "./DemoBookings";

const DAYS_OF_WEEK = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

const defaultAvailability = {
  monday: { startTime: "09:00", endTime: "17:00", isAvailable: true },
  tuesday: { startTime: "09:00", endTime: "17:00", isAvailable: true },
  wednesday: { startTime: "09:00", endTime: "17:00", isAvailable: true },
  thursday: { startTime: "09:00", endTime: "17:00", isAvailable: true },
  friday: { startTime: "09:00", endTime: "17:00", isAvailable: true },
  saturday: { startTime: "09:00", endTime: "17:00", isAvailable: false },
  sunday: { startTime: "09:00", endTime: "17:00", isAvailable: false },
};

const DAY_KEYS = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];
const REF_YEAR = 2026;
const REF_MONTH = 7;
const REF_BASE_DAY = 16;

export function localToUtcWeekly(localWeekly) {
  if (!localWeekly) return defaultAvailability;
  const utcWeekly = {
    monday: { startTime: "", endTime: "", isAvailable: false },
    tuesday: { startTime: "", endTime: "", isAvailable: false },
    wednesday: { startTime: "", endTime: "", isAvailable: false },
    thursday: { startTime: "", endTime: "", isAvailable: false },
    friday: { startTime: "", endTime: "", isAvailable: false },
    saturday: { startTime: "", endTime: "", isAvailable: false },
    sunday: { startTime: "", endTime: "", isAvailable: false },
  };

  for (let d = 0; d < 7; d++) {
    const dayKey = DAY_KEYS[d];
    const item = localWeekly[dayKey];
    if (item && item.isAvailable && item.startTime && item.endTime) {
      const [sh, sm] = item.startTime.split(":").map(Number);
      const [eh, em] = item.endTime.split(":").map(Number);

      const localStart = new Date(REF_YEAR, REF_MONTH, REF_BASE_DAY + d, sh, sm, 0);
      const localEnd = new Date(REF_YEAR, REF_MONTH, REF_BASE_DAY + d, eh, em, 0);

      const utcDayIdx = localStart.getUTCDay();
      const utcDayKey = DAY_KEYS[utcDayIdx];

      const startUtcStr = `${String(localStart.getUTCHours()).padStart(2, "0")}:${String(localStart.getUTCMinutes()).padStart(2, "0")}`;
      const endUtcStr = `${String(localEnd.getUTCHours()).padStart(2, "0")}:${String(localEnd.getUTCMinutes()).padStart(2, "0")}`;

      utcWeekly[utcDayKey] = {
        startTime: startUtcStr,
        endTime: endUtcStr,
        isAvailable: true,
      };
    }
  }

  return utcWeekly;
}

export function utcToLocalWeekly(utcWeekly) {
  if (!utcWeekly) return defaultAvailability;
  const localWeekly = {
    monday: { startTime: "09:00", endTime: "17:00", isAvailable: false },
    tuesday: { startTime: "09:00", endTime: "17:00", isAvailable: false },
    wednesday: { startTime: "09:00", endTime: "17:00", isAvailable: false },
    thursday: { startTime: "09:00", endTime: "17:00", isAvailable: false },
    friday: { startTime: "09:00", endTime: "17:00", isAvailable: false },
    saturday: { startTime: "09:00", endTime: "17:00", isAvailable: false },
    sunday: { startTime: "09:00", endTime: "17:00", isAvailable: false },
  };

  for (let d = 0; d < 7; d++) {
    const utcDayKey = DAY_KEYS[d];
    const item = utcWeekly[utcDayKey];
    if (item && item.isAvailable && item.startTime && item.endTime) {
      const [ush, usm] = item.startTime.split(":").map(Number);
      const [ueh, uem] = item.endTime.split(":").map(Number);

      const utcStart = new Date(Date.UTC(REF_YEAR, REF_MONTH, REF_BASE_DAY + d, ush, usm, 0));
      const utcEnd = new Date(Date.UTC(REF_YEAR, REF_MONTH, REF_BASE_DAY + d, ueh, uem, 0));

      const localDayIdx = utcStart.getDay();
      const localDayKey = DAY_KEYS[localDayIdx];

      const startLocalStr = `${String(utcStart.getHours()).padStart(2, "0")}:${String(utcStart.getMinutes()).padStart(2, "0")}`;
      const endLocalStr = `${String(utcEnd.getHours()).padStart(2, "0")}:${String(utcEnd.getMinutes()).padStart(2, "0")}`;

      localWeekly[localDayKey] = {
        startTime: startLocalStr,
        endTime: endLocalStr,
        isAvailable: true,
      };
    }
  }

  return localWeekly;
}

export default function KnowledgePartner() {
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [activeTab, setActiveTab] = useState("profile");
  const [userId, setUserId] = useState("");


  const [googleStatus, setGoogleStatus] = useState({
    connected: false,
    isExpired: false,
    googleAccountEmail: null,
  });
  const [googleLoading, setGoogleLoading] = useState(false);
  const [disconnecting, setDisconnecting] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    linkedinUrl: "",
    smallDesc: "",
    profileImage: "",
    availabilityWeekly: defaultAvailability,
  });

  useEffect(() => {
    fetchProfile();
    fetchGoogleStatus();


    const params = new URLSearchParams(window.location.search);
    const googleParam = params.get("google");
    if (googleParam === "connected") {
      toastSuccess("Google Calendar connected successfully!");

      window.history.replaceState({}, "", window.location.pathname);
      fetchGoogleStatus();
    } else if (googleParam === "error") {
      const message = params.get("message") || "Failed to connect Google Calendar";
      toastError(message);
      window.history.replaceState({}, "", window.location.pathname);
    }
  }, []);

  const fetchProfile = async () => {
    try {
      setInitialLoading(true);
      const res = await apiGet("/api/knowledge-partner/profile");
      if (res && res.data) {
        setFormData({
          name: res.data.name || "",
          email: res.data.email || "",
          linkedinUrl: res.data.linkedinUrl || "",
          smallDesc: res.data.smallDesc || "",
          profileImage: res.data.profileImage || "",
          availabilityWeekly: res.data.availabilityWeekly
            ? utcToLocalWeekly(res.data.availabilityWeekly)
            : defaultAvailability,
        });
        setUserId(res.data.userId || "");
      }
    } catch (err) {
      if (err?.message !== "Profile not found") {
        toastError(err);
      }
    } finally {
      setInitialLoading(false);
    }
  };

  const fetchGoogleStatus = async () => {
    try {
      setGoogleLoading(true);
      const res = await apiGet("/api/knowledge-partner/google/status");
      if (res?.data) {
        setGoogleStatus(res.data);
      }
    } catch (err) {
      console.error("Failed to fetch Google status:", err);
    } finally {
      setGoogleLoading(false);
    }
  };

  const handleGoogleConnect = async () => {
    try {
      const res = await apiGet("/api/knowledge-partner/google/connect");
      if (res?.data?.authUrl) {
        window.location.href = res.data.authUrl;
      }
    } catch (err) {
      toastError(err?.message || "Failed to initiate Google connection");
    }
  };

  const handleGoogleDisconnect = async () => {
    try {
      setDisconnecting(true);
      await apiDelete("/api/knowledge-partner/google");
      setGoogleStatus({ connected: false, googleAccountEmail: null });
      toastSuccess("Google Calendar disconnected");
    } catch (err) {
      toastError(err?.message || "Failed to disconnect");
    } finally {
      setDisconnecting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAvailabilityToggle = (day) => {
    setFormData((prev) => {
      const currentDay = prev.availabilityWeekly[day] || {};
      const nextIsAvailable = !currentDay.isAvailable;

      const newStartTime = nextIsAvailable && !currentDay.startTime ? "09:00" : currentDay.startTime || "09:00";
      const newEndTime = nextIsAvailable && !currentDay.endTime ? "17:00" : currentDay.endTime || "17:00";

      return {
        ...prev,
        availabilityWeekly: {
          ...prev.availabilityWeekly,
          [day]: {
            ...currentDay,
            isAvailable: nextIsAvailable,
            startTime: newStartTime,
            endTime: newEndTime,
          },
        },
      };
    });
  };

  const handleAvailabilityTimeChange = (day, field, value) => {
    setFormData((prev) => ({
      ...prev,
      availabilityWeekly: {
        ...prev.availabilityWeekly,
        [day]: {
          ...prev.availabilityWeekly[day],
          [field]: value,
        },
      },
    }));
  };

  const handleProfileImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleProfileImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onload = () => {
        setFormData((prev) => ({
          ...prev,
          profileImage: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = new FormData();
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("linkedinUrl", formData.linkedinUrl);
      data.append("smallDesc", formData.smallDesc);

      if (!selectedFile) {
        data.append("profileImage", formData.profileImage);
      } else {
        data.append("files", selectedFile);
      }


      const utcWeekly = localToUtcWeekly(formData.availabilityWeekly);
      data.append("availabilityWeekly", JSON.stringify(utcWeekly));

      const response = await apiPost("/api/knowledge-partner/profile", data);
      if (response && response.data && response.data.data) {
        setFormData((prev) => ({
          ...prev,
          profileImage: response.data.data.profileImage,
        }));
      }
      toastSuccess("Knowledge Partner profile saved successfully!");
      setSelectedFile(null);
    } catch (err) {
      toastError(err);
    } finally {
      setLoading(false);
    }
  };

  const getProfileImageUrl = (url) => {
    if (!url) return "";
    if (url.startsWith("http") || url.startsWith("data:")) return url;
    return `${API_URL}/${url}`;
  };

  if (initialLoading) {
    return (
      <div className="flex justify-center items-center min-h-[60vh]">
        <LuLoader className="w-10 h-10 text-[#313C4C] animate-spin" />
      </div>
    );
  }

  const activeDaysCount = DAYS_OF_WEEK.filter(
    (day) => formData.availabilityWeekly[day]?.isAvailable
  ).length;

  const profileImageUrl = getProfileImageUrl(formData.profileImage || getCurrentUserProfileImage());

  return (
    <div className="min-h-[calc(100vh-110px)] text-slate-800 p-2 sm:p-3 bg-slate-50/50">
      <div className={`mx-auto bg-white p-3 sm:p-4 rounded-none shadow-xs border border-slate-200 transition-all duration-300 ${activeTab === "bookings" ? "max-w-7xl" : "max-w-4xl"
        }`}>

        {/* Header Section */}
        <div className="flex items-center mb-3">
          <div
            className="relative mr-4 cursor-pointer group"
            onClick={handleProfileImageClick}
          >
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full border border-slate-200 shadow-2xs bg-slate-100 text-[#313C4C] flex items-center justify-center overflow-hidden">
              {profileImageUrl ? (
                <img src={profileImageUrl} alt="Profile" className="w-full h-full object-cover" />
              ) : (
                <span className="text-xl font-medium">
                  {formData.name?.charAt(0)?.toUpperCase()}
                </span>
              )}
            </div>
            <div className="absolute bottom-0 right-0 bg-[#313C4C] text-white rounded-full p-1 shadow-2xs group-hover:bg-[#1e293b] transition-colors">
              <LuCamera className="w-3 h-3" />
            </div>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleProfileImageChange}
              className="hidden"
            />
          </div>

          <div className="flex flex-col">
            <h1 className="text-sm font-medium text-slate-900 uppercase tracking-wider mb-0.5">
              Knowledge Partner
            </h1>
            <p className="text-[11px] text-slate-500 font-medium">
              Manage your profile, calendar connection, and demo bookings
            </p>
          </div>
        </div>

        <hr className="border-slate-200 mb-3" />

        {/* Tab Toggle */}
        {googleStatus.connected && (
          <div className="flex gap-1 mb-4 bg-slate-100 p-1 rounded-none border border-slate-200 w-fit">
            {[
              { key: "profile", label: "Profile", icon: LuUser },
              { key: "bookings", label: "Demo Bookings", icon: LuCalendar },
            ].map(({ key, label, icon: Icon }) => (
              <button
                key={key}
                type="button"
                onClick={() => setActiveTab(key)}
                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-none text-[11px] font-medium uppercase tracking-wider transition-all ${activeTab === key
                  ? "bg-[#313C4C] text-white shadow-2xs"
                  : "text-slate-600 hover:text-slate-900"
                  }`}
              >
                <Icon className="w-3.5 h-3.5" />
                {label}
              </button>
            ))}
          </div>
        )}

        {activeTab === "profile" ? (
          <>
            {/* Google Calendar Connection Card */}
            <div className={`mb-4 p-3 rounded-none border transition-all ${googleStatus.connected
              ? googleStatus.isExpired
                ? "border-amber-400 bg-amber-50/60"
                : "border-emerald-300 bg-emerald-50/40"
              : "border-slate-200 bg-slate-50/70"
              }`}>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                <div className="flex items-center gap-3">
                  <div className={`w-9 h-9 rounded-none border flex items-center justify-center ${googleStatus.connected
                    ? googleStatus.isExpired
                      ? "bg-amber-100 border-amber-200"
                      : "bg-emerald-100 border-emerald-200"
                    : "bg-white border-slate-200"
                    }`}>
                    <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none">
                      <path d="M17.5 4H6.5C5.12 4 4 5.12 4 6.5V17.5C4 18.88 5.12 20 6.5 20H17.5C18.88 20 20 18.88 20 17.5V6.5C20 5.12 18.88 4 17.5 4Z" fill="#4285F4" />
                      <path d="M17.5 4H12V12L17.5 8.5V4Z" fill="#EA4335" />
                      <path d="M12 12L6.5 8.5V17.5C6.5 18.05 6.95 18.5 7.5 18.5H12V12Z" fill="#34A853" />
                      <path d="M17.5 8.5L12 12V18.5H17.5C18.05 18.5 18.5 18.05 18.5 17.5V8.5H17.5Z" fill="#FBBC04" />
                      <path d="M6.5 8.5V4H6.5C5.12 4 4 5.12 4 6.5V8.5H6.5Z" fill="#4285F4" opacity="0.5" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-medium text-[11px] text-slate-900 uppercase tracking-wider">
                      Google Calendar {googleStatus.isExpired && <span className="text-amber-800 text-[10px] font-medium ml-1.5 px-1.5 py-0.5 rounded-none bg-amber-100 border border-amber-300">Access Expired</span>}
                    </h3>
                    {googleLoading ? (
                      <p className="text-[11px] text-slate-500 font-medium">Checking connection...</p>
                    ) : googleStatus.connected ? (
                      googleStatus.isExpired ? (
                        <div className="flex items-center gap-1.5">
                          <span className="w-1.5 h-1.5 rounded-none bg-amber-500 animate-pulse" />
                          <p className="text-[11px] text-amber-800 font-medium">
                            Access expired for {googleStatus.googleAccountEmail}. Please reconnect.
                          </p>
                        </div>
                      ) : (
                        <div className="flex items-center gap-1.5">
                          <span className="w-1.5 h-1.5 rounded-none bg-emerald-600" />
                          <p className="text-[11px] text-emerald-700 font-medium">
                            Connected as {googleStatus.googleAccountEmail}
                          </p>
                        </div>
                      )
                    ) : (
                      <p className="text-[11px] text-slate-500 font-medium">
                        Connect your Google Calendar to enable demo booking
                      </p>
                    )}
                  </div>
                </div>

                {!googleLoading && (
                  googleStatus.connected ? (
                    googleStatus.isExpired ? (
                      <div className="flex items-center gap-2">
                        <button
                          type="button"
                          onClick={handleGoogleConnect}
                          className="flex items-center gap-1.5 px-3 py-1.5 bg-[#313C4C] text-white rounded-none text-[11px] font-medium uppercase tracking-wider hover:bg-[#1e293b] transition-colors shadow-2xs"
                        >
                          <LuRefreshCw className="w-3 h-3" />
                          Reconnect
                        </button>
                        <button
                          type="button"
                          onClick={handleGoogleDisconnect}
                          disabled={disconnecting}
                          className="flex items-center gap-1.5 px-3 py-1.5 border border-slate-300 text-slate-700 bg-white hover:bg-slate-100 rounded-none text-[11px] font-medium uppercase tracking-wider transition-colors disabled:opacity-50"
                        >
                          {disconnecting ? (
                            <LuLoader className="w-3 h-3 animate-spin" />
                          ) : (
                            <LuUnplug className="w-3 h-3" />
                          )}
                          Disconnect
                        </button>
                      </div>
                    ) : (
                      <button
                        type="button"
                        onClick={handleGoogleDisconnect}
                        disabled={disconnecting}
                        className="flex items-center gap-1.5 px-3 py-1.5 border border-rose-300 text-rose-700 bg-white hover:bg-rose-50 rounded-none text-[11px] font-medium uppercase tracking-wider transition-colors disabled:opacity-50"
                      >
                        {disconnecting ? (
                          <LuLoader className="w-3 h-3 animate-spin" />
                        ) : (
                          <LuUnplug className="w-3 h-3" />
                        )}
                        Disconnect
                      </button>
                    )
                  ) : (
                    <button
                      type="button"
                      onClick={handleGoogleConnect}
                      className="flex items-center gap-1.5 px-3.5 py-1.5 bg-[#313C4C] text-white rounded-none text-[11px] font-medium uppercase tracking-wider hover:bg-[#1e293b] transition-colors shadow-2xs"
                    >
                      <LuCheck className="w-3 h-3" />
                      Connect
                    </button>
                  )
                )}
              </div>
            </div>

            {/* Availability Section */}
            <h2 className="text-[11px] font-medium text-[#313C4C] uppercase tracking-wider mb-2">Weekly Availability</h2>

            <div className="p-3 bg-slate-50 border border-slate-200 rounded-none flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
              <div>
                <h3 className="font-medium text-[11px] text-slate-800 mb-1.5 uppercase tracking-wider">
                  {activeDaysCount} Days Available
                </h3>
                <div className="flex gap-1.5">
                  {DAYS_OF_WEEK.map((day) => {
                    const isActive = formData.availabilityWeekly[day]?.isAvailable;
                    return (
                      <div
                        key={day}
                        title={isActive ? `${day} (Available)` : `${day} (Unavailable)`}
                        className={`w-6 h-6 rounded-none flex items-center justify-center text-[11px] font-medium transition-all ${isActive
                          ? "bg-[#313C4C] text-white shadow-2xs"
                          : "bg-slate-200 text-slate-500"
                          }`}
                      >
                        {day.charAt(0).toUpperCase()}
                      </div>
                    );
                  })}
                </div>
              </div>

              <button
                type="button"
                onClick={() => setModalOpen(true)}
                className="flex items-center gap-1.5 px-3 py-1.5 border border-[#313C4C] text-[#313C4C] bg-white hover:bg-[#313C4C] hover:text-white rounded-none text-[11px] font-medium uppercase tracking-wider transition-colors"
              >
                <LuCalendar className="w-3 h-3" />
                Edit Schedule
              </button>
            </div>


            {/* Form Section */}
            <form onSubmit={handleSubmit}>
              <h2 className="text-[11px] font-medium text-[#313C4C] uppercase tracking-wider my-3">General Details</h2>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-4">
                {/* Full Name */}
                <div>
                  <label className="block text-[11px] font-medium text-slate-600 uppercase tracking-widest mb-1">Full Name</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
                      <LuUser className="h-3.5 w-3.5 text-slate-400" />
                    </div>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full pl-8 pr-3 py-1.5 bg-white border border-slate-300 rounded-none text-[11px] font-medium focus:outline-none focus:border-[#313C4C] transition-colors shadow-2xs"
                    />
                  </div>
                </div>

                {/* Email */}
                <div>
                  <label className="block text-[11px] font-medium text-slate-600 uppercase tracking-widest mb-1">Email Address</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
                      <LuMail className="h-3.5 w-3.5 text-slate-400" />
                    </div>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full pl-8 pr-3 py-1.5 bg-white border border-slate-300 rounded-none text-[11px] font-medium focus:outline-none focus:border-[#313C4C] transition-colors shadow-2xs"
                    />
                  </div>
                </div>

                {/* LinkedIn Profile */}
                <div className="sm:col-span-2">
                  <label className="block text-[11px] font-medium text-slate-600 uppercase tracking-widest mb-1">LinkedIn Profile URL</label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none">
                      <LuLinkedin className="h-3.5 w-3.5 text-slate-400" />
                    </div>
                    <input
                      type="url"
                      name="linkedinUrl"
                      value={formData.linkedinUrl}
                      onChange={handleChange}
                      placeholder="https://linkedin.com/in/username"
                      className="w-full pl-8 pr-3 py-1.5 bg-white border border-slate-300 rounded-none text-[11px] font-medium focus:outline-none focus:border-[#313C4C] transition-colors shadow-2xs"
                    />
                  </div>
                </div>

                {/* Description */}
                <div className="sm:col-span-2">
                  <label className="block text-[11px] font-medium text-slate-600 uppercase tracking-widest mb-1">Short Description & Expertise</label>
                  <div className="relative">
                    <div className="absolute top-2.5 left-2.5 pointer-events-none">
                      <LuFileText className="h-3.5 w-3.5 text-slate-400" />
                    </div>
                    <textarea
                      name="smallDesc"
                      value={formData.smallDesc}
                      onChange={handleChange}
                      rows={4}
                      placeholder="Briefly describe your background, expertise, and how you can help users..."
                      className="w-full pl-8 pr-3 py-1.5 bg-white border border-slate-300 rounded-none text-[11px] font-medium focus:outline-none focus:border-[#313C4C] transition-colors resize-none shadow-2xs"
                    />
                  </div>
                </div>
              </div>


              <hr className="border-slate-200 my-4" />

              {/* Action Buttons */}
              <div className="flex justify-end">
                <button
                  type="submit"
                  disabled={loading}
                  className="flex items-center gap-1.5 bg-[#313C4C] text-white px-5 py-1.5 rounded-none font-medium text-[11px] uppercase tracking-wider hover:bg-[#1e293b] focus:outline-none transition-all disabled:opacity-70 disabled:cursor-not-allowed shadow-sm"
                >
                  {loading ? (
                    <LuLoader className="w-3.5 h-3.5 animate-spin" />
                  ) : (
                    <LuSave className="w-3.5 h-3.5" />
                  )}
                  {loading ? "Saving..." : "Save Profile"}
                </button>
              </div>
            </form>
          </>
        ) : (
          <DemoBookings userId={userId} />
        )}
      </div>

      {/* Manage Schedule Modal */}
      <CustomAddModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        title="Manage Weekly Schedule"
        onSubmitConfirm={() => setModalOpen(false)}
        saveLabel="Done"
        maxWidth="sm"
      >
        <div className="py-1">
          {DAYS_OF_WEEK.map((day) => {
            const dayData = formData.availabilityWeekly[day] || { isAvailable: false, startTime: "09:00", endTime: "17:00" };

            return (
              <div key={day} className="flex items-center py-2 border-b border-slate-100 border-dashed last:border-0 last:pb-0">

                {/* Toggle & Label */}
                <div className="w-36 flex items-center gap-1.5">
                  <Switch
                    checked={Boolean(dayData.isAvailable)}
                    onChange={() => handleAvailabilityToggle(day)}
                    color="primary"
                    size="small"
                  />
                  <span className={`capitalize text-[11px] font-medium ${dayData.isAvailable ? 'text-slate-900' : 'text-slate-500'}`}>
                    {day}
                  </span>
                </div>

                {/* Time Inputs */}
                <div className="flex-1 flex justify-end">
                  {dayData.isAvailable ? (
                    <div className="flex items-center gap-2">
                      <input
                        type="time"
                        value={dayData.startTime}
                        onChange={(e) => handleAvailabilityTimeChange(day, "startTime", e.target.value)}
                        className="w-28 px-2 py-1 text-[11px] font-medium bg-white border border-slate-300 rounded-none focus:outline-none focus:border-[#313C4C] transition-colors"
                      />
                      <span className="text-[10px] text-slate-400 font-medium">to</span>
                      <input
                        type="time"
                        value={dayData.endTime}
                        onChange={(e) => handleAvailabilityTimeChange(day, "endTime", e.target.value)}
                        className="w-28 px-2 py-1 text-[11px] font-medium bg-white border border-slate-300 rounded-none focus:outline-none focus:border-[#313C4C] transition-colors"
                      />
                    </div>
                  ) : (
                    <span className="text-[11px] italic text-slate-400 pr-2 font-medium">Unavailable</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </CustomAddModal>
    </div>
  );
}